import { CrudFormItemMenuItem } from './crud-form-item-menu-item.interface';

export interface CrudFormItemMenu {
  items: CrudFormItemMenuItem[];
}
